import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  standalone: true,
  selector: 'ef-login-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, NgOptimizedImage],
  template: `<div
    class="md:h-full max-w-[600px] mx-auto lg:w-[600px] aspect-[347/450] bg-[url(assets/empikfoto/images/login-banner.png)] bg-cover bg-top flex flex-col justify-between"
  >
    <div class="flex flex-col justify-center p-4 md:p-10">
      <div class="text-center">
        <h2
          class="text-heading-05 md:text-heading-04 text-black leading-snug mb-1"
          [innerHTML]="'login-banner-header-text' | translate"
        ></h2>
        <p [innerHTML]="'login-banner-description-text' | translate"></p>
      </div>
    </div>
  </div>`,
})
export class EfLoginBannerComponent {}
